import {
  BlankSlateIcon,
  Box,
  Button,
  FileUploadButton,
  Text,
  Tooltip
} from "@prismicio/editor-ui"

import { textConstants } from "../../constants/text"

interface DefaultSidepaneContentProps {
  onFilesUpload: (files: File[]) => void
  isUploading: boolean
  isInitialLoad?: boolean
}
export function DefaultSidepaneContent(props: DefaultSidepaneContentProps) {
  const { onFilesUpload, isUploading, isInitialLoad = false } = props

  const disabled = isInitialLoad || isUploading
  return (
    <Box
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      padding={16}
      gap={16}
      width="100%"
    >
      <BlankSlateIcon
        name="cloudUpload"
        lineColor="purple11"
        backgroundColor="purple5"
        size="large"
      />
      <Box flexDirection="column" gap={4}>
        <Text align="center">
          Select or{" "}
          <FileUploadButton
            disabled={disabled}
            onFilesSelected={onFilesUpload}
            renderButton={(onClick) => (
              <Tooltip
                title={textConstants.warning.uploadWhileUploading.title}
                content={textConstants.warning.uploadWhileUploading.description}
                visible={isUploading}
              >
                <Box display="inline-flex" as="span">
                  <Button disabled={disabled} onClick={onClick} invisible>
                    upload
                  </Button>
                </Box>
              </Tooltip>
            )}
          />{" "}
          media.
        </Text>

        {/* 
            This text should be enabled once tags have been introduced into the media library
            Planned for milestone 2: https://linear.app/prismic/project/media-lib-ui-2918715c543d/PBD
           */}
        {/* <Text color="grey11" variant="small">
            Then manage them with tags.
          </Text> */}
      </Box>

      <FileUploadButton
        disabled={disabled}
        onFilesSelected={onFilesUpload}
        color="grey"
      >
        Upload media
      </FileUploadButton>
    </Box>
  )
}
